/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import "./Input.css";

import * as React from "react";
import { HTMLInputTypeAttribute } from "react";
import { ReactComponent as DeleteIcon } from "../images/icons/delete.svg";
import { ReactComponent as ChevronUpIcon } from "../images/icons/input-chevron-up.svg";
import { ReactComponent as ChevronDownIcon } from "../images/icons/input-chevron-down.svg";

type Props = Readonly<{
  "data-test-id"?: string;
  label?: string;
  onChange: (val: string) => void;
  placeholder?: string;
  value: string;
  type?: HTMLInputTypeAttribute;
  showClear?: boolean;
}>;

export default function TextInput({ label, value, onChange, placeholder = "", "data-test-id": dataTestId, type = "text", showClear = false }: Props): JSX.Element {
  return (
    <div className="Input__wrapper">
      {label && <label className="Input__label">{label}</label>}
      <input
        type={type}
        className="Input__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        data-test-id={dataTestId}
      />
      {type === "number" && (
        <div className="Input__spin-buttons">
          <button onClick={() => onChange(String(Number(value) + 1))}>
            <ChevronUpIcon />
          </button>
          <button onClick={() => onChange(String(Number(value) - 1))}>
            <ChevronDownIcon />
          </button>
        </div>
      )}
      {showClear && value !== "" && (
        <button className="Input__clear" onClick={() => onChange("")}>
          <DeleteIcon />
        </button>
      )}
    </div>
  );
}
